import { api } from '../index';
import { TAxiosResponse } from '../baseApiTypes';

export const getCountBlockData = (): TAxiosResponse<any> =>
  api.get('/count-block');

export const CountBlockApi = {
  getCountBlockData,
};